export default __webpack_public_path__ + "static/media/Flag_of_Ecuador.85723273.svg";